/*
  We store a single global implementation of the VersionBridge as a permanent
  non-enumerable symbol property of the Array constructor (a shared host object).
    
  This ensures all copies of the @sail/version-bridge package (hopefully just one)
  will share the same VersionBridge implementation.
*/ function initVersionBridge() {
    var key = '@sail/version-bridge';
    var host = Array;
    if (!host[key]) {
        Object.defineProperty(host, key, {
            value: {
            },
            configurable: false,
            enumerable: false,
            writable: false
        });
    }
    return host[key];
}
var state = initVersionBridge();
export var versionBridge = new Proxy(state, {
    set: function set(target, p, value) {
        var key = p;
        if (key in target) {
            /*
        If the key has already been registered in the version bridge,
        it probably means you've included multiple versions of a Sail package.
        
        Since the value should be a singleton, we need to ignore subsequent setter calls 
        to guarantee a consistent value.

        We can't safely throw here, without causing issues with any future decision to
        *intentionally* include multiple versions of a sail package.
      */ return true;
        }
        target[key] = value;
        return true;
    }
});

//# sourceMappingURL=versionBridge.js.map